import { GlobalDrawerParams, useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import { useLabel } from "@/core/context/LabelsContext"
import UnsavedChangesModalProvider, {
  useInitUnsavedChangesModalContext,
} from "@/core/context/UnsavedChangesModalProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoDrawer, DiscoDrawerHeader, DiscoText } from "@disco-ui"
import { QueryParamTab } from "@disco-ui/tabs/DiscoQueryParamTabs"
import lazyWithRetry from "@utils/lazy/lazyWithRetry"

const CommunityEngagementBotSettingsDrawerContent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "community-engagement-bot-settings-drawer-content" */ "@/admin/integrations/community-engagement-bot/CommunityEngagementBotSettingsDrawerContent"
    )
)

export default function CommunityEngagementBotSettingsDrawer() {
  const drawer = useGlobalDrawer("communityEngagementBotSettings")
  const modal = useInitUnsavedChangesModalContext()
  const classes = useStyles()
  const organizationLabel = useLabel("organization")

  const tabs: QueryParamTab<GlobalDrawerParams<"communityEngagementBotSettings">>[] = [
    {
      label: "Details",
      params: { communityEngagementBotTab: "details" },
      testid: "details",
    },
    {
      label: "Sources",
      params: { communityEngagementBotTab: "sources" },
      testid: "sources",
    },
  ]

  return (
    // If leaving with unsaved changes, display the unsaved changes modal
    <UnsavedChangesModalProvider {...modal}>
      <DiscoDrawer
        open={drawer.isOpen}
        onClose={handleCloseDrawer}
        size={"large"}
        containerClasses={{
          drawerContainer: classes.drawer,
        }}
      >
        <DiscoDrawerHeader
          title={
            <DiscoText variant={"heading-sm-600"}>
              {`${organizationLabel.singular} Engagement Settings`}
            </DiscoText>
          }
          onClose={handleCloseDrawer}
          className={classes.drawerHeader}
          disableExpand
          queryParamTabs={tabs}
        />
        <CommunityEngagementBotSettingsDrawerContent />
      </DiscoDrawer>
    </UnsavedChangesModalProvider>
  )

  function handleCloseDrawer() {
    // Check that there are no unsaved changes before closing
    modal.handleLeave({
      onLeave: drawer.close,
    })
  }
}

const useStyles = makeUseStyles((theme) => ({
  drawerHeader: {
    padding: theme.spacing(2.5, 2.5, 0),
  },
  drawer: {
    padding: 0,
  },
}))
